import { SeriesType } from "../types/types";

/** 20 distinct colors for pump series. */
export const SERIES_COLORS = [
	"#e87722",
	"#2e7d32",
	"#1565c0",
	"#c62828",
	"#6a1b9a",
	"#00838f",
	"#ef6c00",
	"#4527a0",
	"#ad1457",
	"#33691e",
	"#0277bd",
	"#bf360c",
	"#5d4037",
	"#37474f",
	"#f9a825",
	"#00695c",
	"#283593",
	"#d81b60",
	"#558b2f",
	"#6d4c41",
] as const;

export const SYSTEM_CURVE_COLOR = "#000000";
export const DUTY_POINT_COLOR = "#f4c400";

/** Dataset label used to single the duty point out of legend and tooltips. */
export const DUTY_POINT_LABEL = "Your Duty Point";

export const SERIES_TYPES: SeriesType[] = ["sewage", "grinder"];

export const SERIES_TYPE_LABELS: Record<SeriesType, string> = {
	sewage: "Sewage",
	grinder: "Grinder",
};
